export default "__VITE_ASSET__9jJFtiUl__"